const modalOpenBtns = document.querySelectorAll('.modal-window-trigger');
const modalCloseBtns = document.querySelectorAll('.js-modal-window-close');
const modalBlockContainer = document.querySelector('.modal-body');
const modalWindow = document.querySelector(".modal");

modalOpenBtns.forEach(btn => {
  btn.addEventListener("click", ()=>{
		console.log('click')
		buildModalWindow((JSON.parse(btn.dataset.options)["userVideo"]),modalBlockContainer);
})
})

modalCloseBtns.forEach(closeBtn => {
  closeBtn.addEventListener("click", ()=>{
 	closeModalWindow(document.querySelector('.modal-body__video-block'));
})
})

function closeModalWindow(videoBlock){
	modalWindow.classList.remove('is-open');
  	setTimeout(function(){videoBlock.remove()},350);
}

function buildModalWindow(el){
  console.log('from FUNC')
  console.log(el)
  console.log(modalBlockContainer)
  console.log(modalWindow)
  modalWindow.classList.add('is-open');
  const videoBlock = document.createElement('div');
  videoBlock.classList.add('modal-body__video-block');
  videoBlock.innerHTML +=`
<iframe src=${el}></iframe>`;
  modalBlockContainer.classList.add('modal-body--video');
  modalBlockContainer.append(videoBlock);
}